import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

import PatientJourneyCardTitle from './PatientJourneyCardTitle';
import PatientJourneyCardSubheader from './PatientJourneyCardSubheader';
import PatientJourneyCardContent from './PatientJourneyCardContent';

const styles = (theme) => ({
  card: {
    width: '100%',
  },
  cardHeader: {
    paddingTop: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
  },
});

class PatientJourneyCard extends Component {
  render() {
    const { classes, event, patient, onClickMessages } = this.props;

    return (
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title={<PatientJourneyCardTitle event={event} patient={patient} />}
          subheader={<PatientJourneyCardSubheader event={event} />}
        />
        <PatientJourneyCardContent event={event} onClickMessages={onClickMessages} />
      </Card>
    );
  }
}

PatientJourneyCard.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  patient: PropTypes.object,
  onClickMessages: PropTypes.func.isRequired,
};

export default withStyles(styles)(PatientJourneyCard);
